module.exports = __webpack_public_path__ + "static/ARTS_LOGO_Yatay-ec8de1a8ffa710e9e685170ced47c73d.png";